import React, { useEffect, useState } from "react";
import { TbArrowBackUp } from "react-icons/tb";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { RiSave2Fill } from "react-icons/ri";
import axios from "axios";
import { toast } from "react-toastify";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCameraFill } from "react-icons/bs";
import Loader from "../../Shared_Components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { addCustomerHead } from "../../Redux/Action/CustomerHeadActions";
import { ADD_CUSTOMER_HEAD_SUCCESS } from "../../Redux/Constants/CustomerHeadConstants";
import { API_HOST } from "../../api_utils";
import { MdOutlineKeyboardBackspace } from "react-icons/md";

function CustomerDetailHeader(props) {
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const [customerIdExists, setCustomerIdExists] = useState(false);
  const [customerHeadDataFromApi, setCustomerHeadDataFromApi] = useState([]);

  // use Store to access customer head data:
  const { customerHeadData, loading, error } = useSelector(
    (state) => state.addCustomerHeadData
  );

  const { userDataFromStorage, coloredTheme } = props;

  // states if customer id does not exists:
  const [customer_name, setCustomer_name] = useState("");
  const [customer_status, setCustomer_status] = useState("");
  const [customer_number, setCustomer_number] = useState("");
  const [gender, setGender] = useState("");
  const [max_loan_amount, setMax_loan_amount] = useState("");
  const [photo, setPhoto] = useState("");
  const [headerSuccessFromApi, setHeaderSuccessFromApi] = useState(false);

  // loading and error states:
  const [imageLoading, setImageLoading] = useState(false);

  const { id } = useParams();

  const checkCustomerIdCall = async () => {
    // const num = parseInt(id.replace(/-/g, ''))

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    const payloadData = {
      customerId_check_variable: id,
    };

    const { data } = await axios.post(
      `${API_HOST}/api/customer_head/check_head_id`,
      payloadData,
      config
    );
    if (data) {
      if (data.message) {
        setCustomerIdExists(false);
      } else {
        setCustomerIdExists(true);
        setCustomerHeadDataFromApi(data);
      }
    } else {
      toast.error("Something Went Wrong !!!");
    }
  };

  useEffect(() => {
    checkCustomerIdCall();
  }, []);

  const customerPicHandler = async (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    let formData = new FormData();
    formData.append("image", file);
    setImageLoading(true);

    const { data } = await axios.post(`${API_HOST}/api/upload/`, formData);

    if (data) {
      setImageLoading(false);
      if (data.message) {
        toast.error(data.message);
      } else {
        toast.success("Image Uploaded Successfully !!!");
        setPhoto(data);
      }
    }
  };

  const customerHeadHandler = async () => {
    console.log("here123");
    if (customerIdExists) {
      dispatch({
        type: ADD_CUSTOMER_HEAD_SUCCESS,
        payload: customerHeadDataFromApi,
      });
      navigate("/customers/add_nickname");
    } else {
      if (customer_name && id) {
        await dispatch(
          addCustomerHead({
            customer_name,
            // customer_number: parseInt(customer_number),
            customer_status: customer_status || "",
            gender: gender || "",
            max_loan_amount: max_loan_amount || "",
            photo: photo || "",
            customer_id: id,
            // reference_mobile_number: parseInt(customer_number),
          })
        );
        setHeaderSuccessFromApi(true);
      } else {
        toast.error("Make Sure To Fill All Fields !!!");
      }
    }
  };

  useEffect(() => {
    if (headerSuccessFromApi) {
      navigate("/customers/add_nickname");
    }
  }, [headerSuccessFromApi]);

  useEffect(() => {
    if (!loading && !error && customerHeadData && customerIdExists) {
      console.log("detail here");
      navigate("/customers/add_nickname");
    }
  }, [customerHeadData]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      {imageLoading ? (
        <Loader />
      ) : (
        <>
          <div className="flex justify-start items-center space-x-4">
            <p
              onClick={() => navigate("/customers/detail_id")}
              className="text-[2.3rem] text-gray-700 hover:text-gray-300 transition duration-[0.5s]">
              <MdOutlineKeyboardBackspace />
            </p>
            <p className="text-gray-800 text-[1.8rem] tracking-wider">
              Customer Detail
            </p>
          </div>

          <div
            className={
              customerIdExists
                ? "bg-white pb-[1rem] "
                : "bg-white pb-[1rem] pt-[0.3rem] px-[0.5rem] mt-4 "
            }>
            <p
              style={{ backgroundColor: coloredTheme }}
              className={
                customerIdExists
                  ? " text-white px-[0.5rem] py-[1rem] mt-6"
                  : "hidden"
              }>
              Customer Already Exists
            </p>
            <div className="px-[0.5rem] ">
              {/* customer Id */}
              <div className="flex justify-start items-center font-Roboto mt-2">
                <label htmlFor="customerId" className="text-gray-700 w-[15rem]">
                  Customer ID
                </label>
                <input
                  id="customerId"
                  value={
                    customerIdExists ? customerHeadDataFromApi.customer_id : id
                  }
                  className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                  placeholder="Enter Customer Name"
                  disabled={true}
                />
              </div>

              {/* customer name */}
              <div className="flex justify-start items-center font-Roboto mt-2">
                <label
                  htmlFor="customerName"
                  className="text-gray-700 w-[15rem]">
                  Customer Name
                </label>
                <input
                  onChange={(e) => setCustomer_name(e.target.value)}
                  id="customerName"
                  value={
                    customerIdExists
                      ? customerHeadDataFromApi.customer_name
                      : customer_name
                  }
                  className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                  placeholder="Enter Customer Name"
                  disabled={customerIdExists ? true : false}
                />
              </div>

              {/* customer status */}
              <div className="flex justify-start items-center font-Roboto mt-2">
                <p className="text-gray-700 w-[15rem]">Customer Status</p>
                <select
                  onChange={(e) => setCustomer_status(e.target.value)}
                  disabled={customerIdExists ? true : false}
                  value={
                    customerIdExists
                      ? customerHeadDataFromApi.customer_status
                      : customer_status
                  }
                  className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none">
                  <option value={"none"}>Select A Status</option>
                  <option value={"good"}>Good </option>
                  <option value={"bad"}>Bad</option>
                  <option value={"block"}>Block</option>
                </select>
              </div>

              {/* customer Gender */}
              <div className="flex justify-start items-center font-Roboto mt-2">
                <p className="text-gray-700 w-[15rem]">Customer Gender</p>
                <select
                  onChange={(e) => setGender(e.target.value)}
                  disabled={customerIdExists ? true : false}
                  value={
                    customerIdExists ? customerHeadDataFromApi.gender : gender
                  }
                  className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none">
                  <option value={"none"}>Select A Gender</option>
                  <option value={"Male"}>Male </option>
                  <option value={"Female"}>Female</option>
                  <option value={"Other"}>Other</option>
                </select>
              </div>

              {/*Max Loan Amount*/}
              <div className="flex justify-start items-center font-Roboto mt-2">
                <label htmlFor="loanAmount" className="text-gray-700 w-[15rem]">
                  Max Loan Amount
                </label>
                <input
                  onChange={(e) => setMax_loan_amount(e.target.value)}
                  id="loanAmount"
                  value={
                    customerIdExists
                      ? customerHeadDataFromApi.max_loan_amount
                      : max_loan_amount
                  }
                  className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                  placeholder="Enter Max Loan Amount"
                  disabled={customerIdExists ? true : false}
                />
              </div>

              {/* customer mobile no */}
              {/* <div className="flex justify-start items-center font-Roboto mt-2">
                <label
                  htmlFor="customerStatus"
                  className="text-gray-700 w-[15rem]">
                  Customer Mobile No
                </label>
                <input
                  onChange={(e) => setCustomer_number(e.target.value)}
                  type="tel"
                  id="customerStatus"
                  value={
                    customerIdExists
                      ? customerHeadDataFromApi.customer_number
                      : customer_number
                  }
                  className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                  placeholder="Enter Customer Number"
                  disabled={customerIdExists ? true : false}
                />
              </div> */}

              {/* customer photo */}
              {customerIdExists ? (
                <div
                  className={
                    customerIdExists
                      ? "flex justify-center   items-center space-x-4 mt-4"
                      : "flex justify-center   items-center space-x-4 mt-8"
                  }>
                  <p className="text-gray-700 w-[15rem]">Customer Photo</p>
                  <div className="p-[0.5rem]  rounded-lg flex-1 ">
                    <img
                      src={customerHeadDataFromApi.photo}
                      className="w-[5rem] h-[5rem] rounded-lg hover:shadow-2xl hover:shadow-black "
                    />
                  </div>
                </div>
              ) : (
                <div className="flex justify-center   items-center space-x-4 mt-8">
                  <div className="group">
                    <label
                      htmlFor="customerPic"
                      className="border group-hover:shadow-2xl flex justify-center items-center rounded-lg px-[2rem] bg-sky-50 group-hover:bg-sky-200 transition duration-[0.6s]   py-[0.5rem] border-[#3b82f6] text-lg text-[#57534e]  ">
                      {" "}
                      <BsCameraFill className="text-[#14b8a6] text-[1.5rem] mr-2 group-hover:text-[#7c3aed] transition duration-[0.6s]" />
                      Upload Customer Photo
                    </label>
                  </div>
                  <input
                    onChange={(e) => customerPicHandler(e)}
                    type="file"
                    id="customerPic"
                    style={{ display: "none" }}
                    placeholder="Enter a Max Loan Amount"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-start items-center space-x-4 mt-8 mb-8">
            <button
              style={{ backgroundColor: coloredTheme }}
              onClick={customerHeadHandler}
              className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
              <RiSave2Fill />
              <p>New Nickname</p>
            </button>
            <button
              style={{ backgroundColor: coloredTheme }}
              onClick={() => navigate("/customers/detail_id")}
              className="flex justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
              <TbArrowBackUp />
              <p>Cancel</p>
            </button>
          </div>
        </>
      )}

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default CustomerDetailHeader;
